import { useEffect, useRef, useState } from 'react'

// Thin EventSource wrapper: auto-reconnects (built into EventSource),
// StrictMode-safe (closes in effect cleanup), and reports connectivity so
// callers can stretch their polling interval while the stream is live.
export function useEventSource(
  url: string | null,
  onEvent: (type: string, data: string) => void,
  eventTypes: string[] = ['notification'],
) {
  const [connected, setConnected] = useState(false)
  const handler = useRef(onEvent)
  handler.current = onEvent

  useEffect(() => {
    if (!url) return
    const es = new EventSource(url)
    es.onopen = () => setConnected(true)
    es.onerror = () => setConnected(false)
    const listeners = eventTypes.map((type) => {
      const fn = (ev: MessageEvent) => handler.current(type, ev.data)
      es.addEventListener(type, fn)
      return [type, fn] as const
    })
    return () => {
      for (const [type, fn] of listeners) es.removeEventListener(type, fn)
      es.close()
      setConnected(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, eventTypes.join(',')])

  return connected
}
